// extracted by mini-css-extract-plugin
export default {"wrapper":"cookie-consent-module--wrapper--a5ce4","message":"cookie-consent-module--message--056ba","btn":"cookie-consent-module--btn--7b4b8"};